'use client'

import { useCallback, useEffect } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { toastActions, type ToastType } from '@/store/toast'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'

import styles from './Toasts.module.scss'

const TOAST_TIMEOUT = 5000

type ToastProps = {
  toast: ToastType
}

const Toast = ({ toast }: ToastProps) => {
  const dispatch = useReduxDispatch()
  const remove = useCallback(() => dispatch(toastActions.remove(toast.key)), [dispatch, toast.key])

  useEffect(() => {
    const timeout = setTimeout(remove, TOAST_TIMEOUT)
    return () => clearTimeout(timeout)
  }, [remove])

  return (
    <ButtonRoot className={styles.toast} onClick={remove}>
      {toast.content}
    </ButtonRoot>
  )
}

export const Toasts = () => {
  const toasts = useReduxSelector((s) => s.toast.toasts)

  return (
    <div className={styles.container} role='status' {...getClickawayIgnoreProps(['collapse-expanded'])}>
      {toasts.map((toast) => (
        <Toast key={toast.key} toast={toast} />
      ))}
    </div>
  )
}
